import * as tokens from '@joinrepublic/dls-ui-core';

import { componentStyles } from './component-styles';
import { createTheme } from './factory';

export const createDlsTheme = () =>
  createTheme({
    name: 'dls',
    tokens: tokens.dls,
    components: componentStyles,
  });

export const theme = createDlsTheme();
